import getConferenceRoomDisplayName from '../services/getConferenceRoomDisplayName';
import type EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import {
    createEnhancedLocationFromRoomInfo,
    createEnhancedLocationFromStringLocation,
    containsRoomWithEmail,
    containsLocationWithId,
    isRoom,
} from 'owa-location-persona';
import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { LocationIdentifier, LocationType } from 'owa-addins-core';
import { updateLocations } from 'owa-calendar-compose-form-actions';

export const addEnhancedLocations = async (
    locationIdentifiers: LocationIdentifier[]
): Promise<void> => {
    const event = getComposeEvent(null /* formId */);
    let newLocations: EnhancedLocation[] = [];
    // filter locations with no ids
    const locationsToAdd = locationIdentifiers.filter(location => !isNullOrWhiteSpace(location.id));
    for (const locationIdentifier of locationsToAdd) {
        // filter duplicate locations
        if (!containsLocationWithId(newLocations, locationIdentifier.id)) {
            if (
                locationIdentifier.type === LocationType.Room &&
                !containsRoomWithEmail(event.Locations, locationIdentifier.id)
            ) {
                const roomName = await getConferenceRoomDisplayName(locationIdentifier.id);
                newLocations.push(
                    createEnhancedLocationFromRoomInfo(
                        roomName ? roomName : locationIdentifier.id,
                        locationIdentifier.id
                    )
                );
            } else if (
                locationIdentifier.type === LocationType.Custom &&
                !containsLocationWithId(event.Locations, locationIdentifier.id)
            ) {
                newLocations.push(createEnhancedLocationFromStringLocation(locationIdentifier.id));
            }
        }
    }
    if (newLocations.length) {
        updateLocations([...event.Locations, ...newLocations]);
    }
};

export const removeEnhancedLocations = (identifiers: LocationIdentifier[]): void => {
    const event = getComposeEvent(null /* formId */);
    // filter the locations that are referenced in location to remove list
    const filteredLocations = event.Locations.filter(location => {
        const locationIsRoom = isRoom(location.PostalAddress);
        return !identifiers.some(
            identifier =>
                (locationIsRoom &&
                    identifier.type === LocationType.Room &&
                    identifier.id.toUpperCase() ===
                        location.PostalAddress.LocationUri.toUpperCase()) ||
                (!locationIsRoom &&
                    identifier.type === LocationType.Custom &&
                    location.DisplayName === identifier.id)
        );
    });

    updateLocations(filteredLocations);
};
